<template>
  <div class="calendar-item">
    <div class="date">
      <div class="day">{{day}}</div>
      <div class="line"></div>
      <div class="month">{{month}}</div>
    </div>
    <div class="year">{{year}}</div>
  </div>
</template>

<script>
export default {
  props: ['date'],
  name: "CalendarItem",
  computed: {
    year() {
      return this.date.substring(0, 4);
    },
    month() {
      return this.date.substring(4, 6);
    },
    day() {
      return this.date.substring(6);
    }
  }
}
</script>

<style lang="less">
.mobile-home {
  .calendar-item {
    width: 70px;
    height: 70px;
    .date {
      display: flex;
      height: 54px;
      background: #037698;
      position: relative;
      .day, .month {
        width: 50%;
        font-size: 30px;
        color: #fff;
        font-weight: bolder;
        transform: scale(.72, 1.08);
      }
      .day {
        align-self: flex-start;
        vertical-align: top;
      }
      .month {
        align-self: flex-end;
        vertical-align: bottom;
      }
      .line {
        width: 1px;
        height: 49px;
        background: #fff;
        position: absolute;
        left: calc((100% - 1px) / 2);
        top: 3px;
        transform: rotate(32deg);
      }
    }
    .year {
      text-align: center;
      border: 1px solid #037698;
      color: #037698;
      letter-spacing: 4px;
      font-size: 14px;
      line-height: 16px;
    }
  }
}
</style>
